import {NgModule} from '@angular/core';
import {Router, RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {ContactComponent} from './contact/contact.component';
import {CapitalsComponent} from './capitals/capitals.component';
import {PhilanthropyComponent} from './philanthropy/philanthropy.component';
import {NewsComponent} from './news/news.component';
import {TeamComponent} from './team/team.component';
import {MissionComponent} from './mission/mission.component';
import {SaurabhMittalComponent} from './team/saurabh-mittal/saurabh-mittal.component';
import {LeadershipComponent} from './team/leadership/leadership.component';
import {InvestmentTeamComponent} from './team/investment-team/investment-team.component';
import {PlatformServicesComponent} from './capitals/platform-services/platform-services.component';
import {MediaComponent} from './capitals/media/media.component';
import {FintechComponent} from './capitals/fintech/fintech.component';
import {AssetComponent} from './capitals/asset/asset.component';
import {MissionCapitalComponent} from './mission-capital/mission-capital.component';
import {CapitalDetailsComponent} from './mission-capital/capital-details/capital-details.component';
import {LookingForComponent} from './mission-capital/looking-for/looking-for.component';
import {CapitalInvestmentComponent} from './mission-capital/capital-investment/capital-investment.component';

const routes: Routes = [
   {
      path: 'home',
      component: HomeComponent,
      pathMatch: 'full'
   },
   {
      path: 'about-mission',
      component: MissionComponent,
      pathMatch: 'full'
   },
   {
      path: 'team',
      component: TeamComponent,
      children: [
         {
            path: 'saurabh-mittal',
            component: SaurabhMittalComponent,
            pathMatch: 'full'
         },
         {
            path: 'leadership',
            component: LeadershipComponent,
            pathMatch: 'full'
         },
         {
            path: 'investment',
            component: InvestmentTeamComponent,
            pathMatch: 'full'
         }
      ]
   },
   {
      path: 'capitals',
      component: CapitalsComponent,
      children: [
         {
            path: 'platform-services',
            component: PlatformServicesComponent,
            pathMatch: 'full'
         },
         {
            path: 'sports',
            component: MediaComponent,
            pathMatch: 'full'
         },
         {
            path: 'fintech',
            component: FintechComponent,
            pathMatch: 'full'
         },
         {
            path: 'asset',
            component: AssetComponent,
            pathMatch: 'full'
         },
         {
            path: 'details',
            component: CapitalDetailsComponent,
            pathMatch: 'full'
         },
      ]
   },
   {
      path: 'missionCapital',
      component: MissionCapitalComponent,
      children: [
         {
            path: 'details',
            component: CapitalDetailsComponent,
            pathMatch: 'full'
         },
         {
            path: 'looking-for',
            component: LookingForComponent,
            pathMatch: 'full'
         },
         {
            path: 'capital-investment',
            component: CapitalInvestmentComponent,
            pathMatch: 'full'
         }
      ]
   },
   {
      path: 'philanthropy',
      component: PhilanthropyComponent,
      pathMatch: 'full'
   },
   {
      path: 'news',
      component: NewsComponent,
      pathMatch: 'full'
   },
   {
      path: 'contact',
      component: ContactComponent,
      pathMatch: 'full'
   },
   {
      path: '**',
      redirectTo: '/home',
      pathMatch: 'full'
   }
];

@NgModule({
   imports: [
      RouterModule.forRoot(routes, {
         useHash: true,
         anchorScrolling: 'enabled'
      })
   ],
   exports: [RouterModule]

})

export class AppRoutingMudule {
}
